// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  BankStackPledge,
} from "./types";

export default {
  bankId: __t.u64(),
  principal: __t.u64(),
  termDays: __t.u32(),
  autopay: __t.bool(),
  maxRateBps: __t.u32(),
  itemIds: __t.array(__t.u64()),
  get stacks() {
    return __t.array(BankStackPledge);
  },
};
